import { Component, OnInit } from '@angular/core';

import Swal from 'sweetalert2'

/**
 * Services 
 */
import { GetOfferingTypeService } from "../../../services/receipts/getOfferingType/get-offering-type.service"
import { GetEventService } from "../../../services/receipts/getEvent/get-event.service"
import { GetEventPaymentService } from "../../../services/receipts/getEventPayment/get-event-payment.service"
import { GetPartnerIDService } from "../../../services/donation/getPartnerID/get-partner-id.service";
import { OnlineOfferingService } from '../../../services/donation/onlineOffering/online-offering.service';


declare var $: any

@Component({
  selector: 'app-donation',
  templateUrl: './donation.component.html',
  styleUrls: ['./donation.component.less']
})
export class DonationComponent implements OnInit {


  public customDonate = [0]

  public offeringTypeData: any
  public event: any
  public eventPayment: any
  public detailSearch: Boolean = false
  public getPartnerID: any = {
    result: "",
    infoResult: "",
    success: false,
    info: false,
    error: false
  }
  public searchDetails: any

  public totalAmount: any

  public getPartnerCodeVia = {
    enter: false,
    search: false
  }

  public searchPartnerCodeVia = {
    email: false,
    mobileNumber: false,
  }

  public skeletonLoader: Boolean = false
  public selectPartnerIDSSkeleton: Boolean = false
  public submitLoading: Boolean = false

  constructor(
    private GetOfferingTypeService: GetOfferingTypeService,
    private GetEventService: GetEventService,
    private GetEventPaymentService: GetEventPaymentService,
    private GetPartnerIDService: GetPartnerIDService,
    private OnlineOfferingService: OnlineOfferingService, 
  ) { 
   }

  async ngOnInit() {

   
  }

  async donate(els) {
    this.submitLoading = true
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      onOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    })
    let data = {
      "partner_id": this.getPartnerID.result.profile.partner_id,
      "parnter_name": this.getPartnerID.result.profile.full_name,
      "email_id": this.getPartnerID.result.profile.email_id,
      "mobile_no": this.getPartnerID.result.profile.primary_mobile_no,
      "prayer_req": els.prayerRequest,
      "total_amount": els.totalAmount,
      "offering_cat_type": await this.keyMapForDynamicFormField(els)
    }
    let result = await this.OnlineOfferingService.OnlineOffering(data)
    this.submitLoading = false
    if (result.status == "success") {
      Toast.fire({
        icon: 'success',
        title: 'successfully added'
      })
      this.searchDetailCancel()
      this.cancelPartnerCode() 
      await this.openWindow(result.url)
    } else {
      Toast.fire({
        icon: 'error',
        title: 'error'
      })
    }
  }

 async openWindow(myURL) {
   let myWidth =1050
   let myHeight = 550
    var left = (screen.width - myWidth) / 2;
    var top = (screen.height - myHeight) / 4;
      window.open(myURL, "BPM Office", 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + myWidth + ', height=' + myHeight + ', top=' + top + ', left=' + left);
      window["CallParentfunction"]= function () {  
        alert("asdsad")
      } 
 }


  keyMapForDynamicFormField(data) {
    let res = []
    for (const key in this.customDonate) {
      if (this.customDonate.hasOwnProperty(key)) {
        const element = this.customDonate[key];
        if (data[`offeringType_${element}`] != "") {
          res.push({ offering_type: data[`offeringType_${element}`], offering_amt: data[`amount_${element}`] })
        } else if (data[`event_${element}`] != "") {
          res.push({ offering_type: data[`eventPayment_${element}`], event_id: data[`event_${element}`], offering_amt: data[`amount_${element}`] })
        }
      }
    }
    return res
  }

  async getDropDown() {
    await this.getOfferingType()
    await this.getEvent()
    await this.getEventPayment()
  }

  async getPartnerIdFromMultiple(id) {
    let data = `partner_id=${id}`
    this.searchDetails = id
    let result = await this.GetPartnerIDService.getPartnerID(data)
    if (result.data != "") {
      this.getPartnerID.success = true
      this.getPartnerID.result = result.data[0]
      this.getPartnerID.error = false
      this.getDropDown()
    } else {
      this.getPartnerID.error = true
      this.getPartnerID.success = false
    }
  }

  async partnerCodeSearch(key) {
    this.getPartnerCodeVia.enter = false
    this.detailSearch = true
    switch (key) {
      case 1:
        this.searchPartnerCodeVia.email = true
        this.searchPartnerCodeVia.mobileNumber = false
        break;
      case 2:
        this.searchPartnerCodeVia.email = false
        this.searchPartnerCodeVia.mobileNumber = true
        break;
    }
  }

  async getPartnerIDCode() {
    let data = `partner_id=${$("#partnerId").val()}`

    this.searchDetails = $("#partnerId").val()
    let result = await this.GetPartnerIDService.getPartnerID(data)
    if (result.data != "") {
      if (result.data.length == 1) {
        this.getPartnerID.success = true
        this.getPartnerID.error = false
        this.getPartnerID.info = false
        this.getPartnerID.result = result.data[0]
        this.getDropDown()
      } else {
        this.getPartnerID.info = true
        this.getPartnerID.success = false
        this.getPartnerID.error = false
        this.getPartnerID.infoResult = result.data 
        setTimeout(function () {
          $(`.partnerIDS`).selectpicker('refresh');
        }, 100)
      }
    } else {
      this.getPartnerID.error = true
      this.getPartnerID.success = false
      this.getPartnerID.info = false
    }
  }


  async getPartnerIDViaEmail() {
    let data = `email_id=${$("#email").val()}`

    this.searchDetails = $("#email").val()
    let result = await this.GetPartnerIDService.getPartnerID(data)
    if (result.data != "") {
      if (result.data.length == 1) {
        this.getPartnerID.success = true
        this.getPartnerID.error = false
        this.getPartnerID.info = false
        this.getPartnerID.result = result.data[0]
        this.getDropDown()
      } else {
        this.getPartnerID.info = true
        this.getPartnerID.success = false
        this.getPartnerID.error = false
        this.getPartnerID.infoResult = result.data
        setTimeout(function () {
          $(`.partnerIDS`).selectpicker('refresh');
        }, 100)
      }
    } else {
      this.getPartnerID.error = true
      this.getPartnerID.success = false
      this.getPartnerID.info = false
    }
  }

  async getPartnerIDCodeViaMobilNumber() {
    let data = `primary_mobile_no=${$("#mobileNumber").val()}`

    this.searchDetails = $("#mobileNumber").val()
    let result = await this.GetPartnerIDService.getPartnerID(data)
    if (result.data != "") {
      if (result.data.length == 1) {
        this.getPartnerID.success = true
        this.getPartnerID.error = false
        this.getPartnerID.info = false
        this.getPartnerID.result = result.data[0]
        this.getDropDown()
      } else {
        this.getPartnerID.info = true
        this.getPartnerID.success = false
        this.getPartnerID.error = false
        this.getPartnerID.infoResult = result.data
        setTimeout(function () {
          $(`.partnerIDS`).selectpicker('refresh');
        }, 100)
      }
    } else {
      this.getPartnerID.error = true
      this.getPartnerID.success = false
      this.getPartnerID.info = false
    }
  }

  async searchDetailCancel() {
    this.customDonate = [0]
    this.totalAmount = 0
    this.getPartnerCodeVia.search = true
    this.detailSearch = false
    this.getPartnerID.success = false
    this.getPartnerID.error = false
    this.getPartnerID.info = false
  }

  async cancelPartnerCode() {
    this.customDonate = [0]
    this.totalAmount = 0
    this.getPartnerCodeVia.enter = false
    this.getPartnerCodeVia.search = false

    this.getPartnerID.success = false
    this.getPartnerID.error = false
    this.getPartnerID.info = false
  }

  async addNewDonationBox(id) {

    let price = $(`#price_${id - 1}`).val()
    let offeringBox = $(`#offeringBox_${id - 1}`).val()
    let event = $(`#event_${id - 1}`).val()
    let eventPayment = $(`#eventPayment_${id - 1}`).val()

    if (price != "" && ((offeringBox == "" && (event != "" || eventPayment != "") || (offeringBox != "" && (event == "" || eventPayment == ""))))) {
      this.customDonate.push(id)
      setTimeout(function () {
        $(`.offeringType_${id}`).selectpicker('refresh');
        $(`.event_${id}`).selectpicker('refresh');
        $(`.eventPayment_${id}`).selectpicker('refresh');
      }, 100)
    } else {
      console.log("asd")
    }


  }

  async removeDonationBox(id) {
    let val = $(`#price_${id}`).val()
    this.totalAmount = this.totalAmount - val
    if (this.customDonate.length != 1) {
      const index = this.customDonate.indexOf(id);
      if (index > -1) {
        this.customDonate.splice(index, 1);
      }
    }
  }
  

  async getOfferingType() {
    let data = await this.GetOfferingTypeService.GetOfferingType()
    this.offeringTypeData = data.data
    setTimeout(function () {
      $(".offeringType_0").selectpicker('refresh');
    }, 100)
  }

  async getEvent() {
    let data = await this.GetEventService.GetEvent()
    this.event = data.data
    setTimeout(function () {
      $(`.event_0`).selectpicker('refresh');
    }, 100)
  }
  async getEventPayment() {

    // let rmArr = [18,19,20,21]

    let data = await this.GetEventPaymentService.GetEventPayment()
    this.eventPayment = data.data
    setTimeout(function () {
      $(`.eventPayment_0`).selectpicker('refresh');
    }, 100)
  }

  async calAmount() {
    this.sumAmount();
  }

  sumAmount() {
    var sum = 0;
    $(".price").each(function () {
      //add only if the value is number 
      if (!isNaN(this.value) && this.value.length != 0) {
        sum += parseFloat(this.value);
      }
    });
    this.totalAmount = sum
  }

  disableEventEventPaymentSelection(val, key) { 
    if (key == 1) {
      if($(`#offeringBox_${val}`).val() != ""){
        $(`[data-id="event_${val}"]`).prop('disabled', true);
        $(`[data-id="eventPayment_${val}"]`).prop('disabled', true);
      }else{
        $(`[data-id="event_${val}"]`).prop('disabled', false);
        $(`[data-id="eventPayment_${val}"]`).prop('disabled', false);
      }
     
    } else if (key == 2) {
      if($(`#event_${val}`).val() != ""){
        $(`[data-id="offeringBox_${val}"]`).prop('disabled', true);
      }else{
        $(`[data-id="offeringBox_${val}"]`).prop('disabled', false);
      } 
    }
  }

  async getPartnerCode(parm) {
    this.skeletonLoader = true
    switch (parm) {
      case "enter":
        setTimeout(() => {
          this.skeletonLoader = false
          this.getPartnerCodeVia.enter = true
          this.getPartnerCodeVia.search = false
        }, 500)

        break;
      case "search":
        setTimeout(() => {
          this.skeletonLoader = false
          this.getPartnerCodeVia.enter = false
          this.getPartnerCodeVia.search = true
        }, 500)
        break;
    }
  }

  keyPressEvent(event: any) {
    const pattern = /[0-9\+\-\ ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if ((event.keyCode != 8 && !pattern.test(inputChar))) {
      event.preventDefault();
    }
  }

}
